import { clsx } from 'clsx';

import styles from './OverlayStepBar.module.css';

export interface OverlayStepBarProps {
  /** Array of strings. */
  stepLabels: string[];
  /** activeStep number starting with 1. */
  activeStep: number;
  /** Array of prefix numbers to not show in the steplabels */
  disabledCountPrefix?: number[];
  /** navigate to step. */
  onStepClick?: (step: number) => void;
}

export const OverlayStepBar = ({
  stepLabels,
  activeStep = 0,
  disabledCountPrefix = [],
  onStepClick,
}: OverlayStepBarProps) => {
  if (activeStep > stepLabels.length) {
    console.error('activeStep is greater than the number of steps');
  }

  const getStepDisplayNumber = (stepIndex: number): string => {
    const stepNumber = stepIndex + 1;

    if (disabledCountPrefix.includes(stepNumber)) {
      return '';
    }

    const enabledStepsBefore = Array.from({ length: stepIndex }, (_, count) => count + 1).filter(
      (step) => !disabledCountPrefix.includes(step)
    ).length;

    return String(enabledStepsBefore + 1);
  };

  return (
    <div className={styles['overlay-step-bar__container']}>
      {stepLabels.length &&
        stepLabels.map((label, index) => (
          <span key={`${index}_${label}`} className={styles[`overlay-step-bar__step-wrapper`]}>
            <button
              className={clsx(styles[`overlay-step-bar__step`], [
                index === activeStep - 1 && styles[`overlay-step-bar__step--active`],
              ])}
              {...(onStepClick && { onClick: () => onStepClick(index + 1) })}
              type="button"
              aria-label={`Step ${index + 1}`}
              aria-current={index === activeStep - 1 ? 'step' : undefined}
              disabled={index === activeStep - 1}
            >
              <span className={styles[`overlay-step-bar__step--index`]}>{getStepDisplayNumber(index)}</span>
              <span
                className={clsx(
                  styles[`overlay-step-bar__step--label`],
                  disabledCountPrefix.includes(index + 1) && styles[`overlay-step-bar__step--label-show`]
                )}
              >
                {label}
              </span>
            </button>
          </span>
        ))}
    </div>
  );
};
